import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { getRequest, postRequest } from "../../../utils/api";
import { logout } from "../../../utils/auth";
import { toast } from "react-toastify";

const AffiliateCommissionModal: React.FC<any> = ({ show, onHide, affiliateData = {} }) => {
    const [loading, setLoading] = useState(false);
    const [commissionLoading, setCommissionLoading] = useState(false);

    const [commissionList, setCommissionList] = useState<any[]>([]);
    const [affiliateId, setAffiliateId] = useState("");
    const [commissionId, setCommissionId] = useState("");

    const fetchCommissionList = async () => {
        try {
            setLoading(true);

            const response = await getRequest(
                "/affiliate/affiliate-commission-tier-list"
            );

            if (response.status === "success") {
                setCommissionList(response.data || []);
            } else if (response.status === "session_expired") {
                logout();
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            console.error(error);
            toast.error("Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (show && affiliateData) {
            setAffiliateId(affiliateData._id)
            setCommissionId(affiliateData.affiliate_referral_commission_id)
            fetchCommissionList();
        }
    }, [show, affiliateData]);

    const handleCommissionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setCommissionId(e.target.value);
    };

    const handleSubmit = async () => {
        if (!commissionId) {
            toast.error("Please select commission");
            return;
        }

        try {
            setCommissionLoading(true);

            const response = await postRequest(
                "/affiliate/change-affiliate-commission-tier",
                {
                    affiliateId: affiliateId,
                    commissionId: commissionId,
                }
            );

            if (response.status === "success") {
                toast.success(response.message); 
                onHide();
            } else if (response.status === "session_expired") {
                logout();
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            console.error(error);
            toast.error("Something went wrong");
        } finally {
            setCommissionLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Commission List</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form>
                    <div className="row">
                        <div className="col-lg-12 mb-3">
                            <Form.Group>
                                <Form.Label>Commission</Form.Label>

                                <Form.Select
                                    value={commissionId}
                                    onChange={handleCommissionChange}
                                    disabled={loading}
                                >
                                    <option value="">
                                        {loading ? "Loading..." : "Select Commission"}
                                    </option>

                                    {commissionList.map((item) => (
                                        <option key={item._id} value={item._id}>
                                            {item.commission_title}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </div>
                    </div>
                </Form>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="outline-secondary" onClick={onHide}>
                    Close
                </Button>

                <Button
                    variant="primary"
                    onClick={handleSubmit}
                    disabled={commissionLoading}
                >
                    {commissionLoading ? "Processing..." : "Submit"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AffiliateCommissionModal;